import * as React from 'react';
import { cn } from '@/lib/utils';

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  /** When true, renders a built-in illustration plate behind the icon. */
  illustrated?: boolean;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  illustrated = true,
  className,
  ...props
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-vt-3 px-vt-5 py-vt-10 text-center',
        className
      )}
      {...props}
    >
      {icon ? (
        <div
          className={cn(
            'relative inline-flex items-center justify-center text-vt-primary',
            illustrated &&
              "before:absolute before:inset-0 before:-z-10 before:m-[-22px] before:rounded-full before:bg-[radial-gradient(circle_at_center,_var(--vt-primary-100)_0%,_transparent_70%)] before:opacity-100"
          )}
          aria-hidden="true"
        >
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-vt-primary-100 text-vt-primary ring-1 ring-vt-primary-400/30">
            {icon}
          </div>
        </div>
      ) : null}
      <div className="mt-vt-2 max-w-md">
        <div className="text-vt-16 font-semibold text-vt-text">{title}</div>
        {description ? (
          <p className="mt-vt-1 text-vt-14 leading-relaxed text-vt-text-muted">{description}</p>
        ) : null}
      </div>
      {action ? <div className="mt-vt-2">{action}</div> : null}
    </div>
  );
}
